window.addEventListener( "scroll" ,function(){

  //スクロールの高さを取得
  let scroll = window.pageYOffset;

  var header = document.getElementById('header');
  
  if( scroll > 1 ){ 
    header.style.backgroundColor = 'rgb(244, 242, 239, 0.86)';
  }else {
    header.style.backgroundColor = 'transparent';
  }

//   if( scroll > 4000 ){ 
//     document.body.style.backgroundColor = '#FFC400';
//   }else if( scroll > 3000 ){
//     document.body.style.backgroundColor = '#43A047';
//   }else if( scroll > 2000 ){
//     document.body.style.backgroundColor = '#FF6F00';
//   }else if( scroll > 1000 ){
//     document.body.style.backgroundColor = '#0091EA';
//   }else{
//     document.body.style.backgroundColor = '#FF4081';
//   }
  
});